// import Button from '@/components/Button'
import Container from '@/components/Container'
import HtmlContent from '@/components/HtmlContent'
import Section from '@/components/Section'
import Title from '@/components/Title'
import { arrowRightIcon } from '@/images'
import { SwiperSlide, Swiper } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import { GxIcon } from '@garpix/garpix-web-components-react'
import React from 'react'
import style from '../styles/best.module.scss'
import PlayButton from '@/components/Button/PlayButton'
import { api } from '@/api'
import useSWR from 'swr'
import { PlaceholderLoading } from '@/components/PlaceholderLoading'
import LessonsSlider from '@/apps/RecommendToKnow/components/LessonsSlider'
import { useLocation } from 'react-router-dom'
// import { useConfig } from '@/hooks'

SwiperCore.use([Navigation])

const Contests = ({
  playVideo,
  setPlayVideo,
  pageTitle
}): React.ReactElement => {
  const { data } = useSWR(
    { url: 'getProfessionCompetition', page_size: 20 },
    api.getProfessionCompetition
  )
  // const config = useConfig()

  const location = useLocation()

  return (
    <Section>
      {data?.results?.map((element) => {
        return (
          <React.Fragment key={element.id}>
            <Container>
              <div className={style.contests_row}>
                <div className={style.contests_left}>
                  {element !== undefined
                    ? (
                      <>
                        <Title
                          type='h2'
                          theme='h3'
                          className={style.contests__title}
                        >
                          {element.name}
                        </Title>
                        <HtmlContent
                          content={element.preview_text}
                          className={style.contests__text}
                        />
                        {/* <Button
                    size='large'
                    wide
                    highlight
                    href={`${config.profession_competition}?element_id=${String(
                    element.id
                  )}`}
                    className={style.contests__button}
                  >
                    Участвовать
                  </Button> */}
                      </>
                      )
                    : (
                      <>
                        <Title
                          type='h2'
                          theme='h3'
                          className={style.contests__title}
                        >
                          <PlaceholderLoading
                            shape='rect'
                            width='100%'
                            height='50px'
                          />
                        </Title>
                        <PlaceholderLoading
                          shape='rect'
                          width='100%'
                          height='200px'
                        />
                      </>
                      )}
                </div>

                <div className={style.contests_right}>
                  <div className={style.slider_buttons_contests}>
                    <button
                      className={`slider_button slider_button_prev js_contests_prev_${String(
                        element.id
                      )}`}
                    >
                      <GxIcon
                        src={arrowRightIcon}
                        className={style.slider__icon}
                      />
                    </button>
                    <button
                      className={`slider_button slider_button_next js_contests_next_${String(
                        element.id
                      )}`}
                    >
                      <GxIcon
                        src={arrowRightIcon}
                        className={style.slider__icon}
                      />
                    </button>
                  </div>

                  <Swiper
                    slidesPerView={1}
                    spaceBetween={20}
                    resizeObserver
                    navigation={{
                      prevEl: `.js_contests_prev_${String(element.id)}`,
                      nextEl: `.js_contests_next_${String(element.id)}`
                    }}
                    freeMode
                    grabCursor
                  >
                    {element === undefined
                      ? (
                        <SwiperSlide className={style.contests_slide}>
                          <PlaceholderLoading
                            shape='rect'
                            width='100%'
                            height='100%'
                          />
                        </SwiperSlide>
                        )
                      : (
                          element.property_videos_value.map((slide) => {
                            return (
                              <SwiperSlide
                                key={slide.id}
                                className={style.contests_slide}
                              >
                                {playVideo ===
                            `contests_slider_${String(slide.id)}`
                                  ? (
                                    <video
                                      width='400px'
                                      height='300px'
                                      controls
                                      controlsList='nodownload'
                                      autoPlay
                                      className={style.slide__video}
                                    >
                                      <source
                                        src={slide.property_video_value?.[0] ?? ''}
                                        type='video/mp4'
                                      />
                                    </video>
                                    )
                                  : (
                                    <>
                                      <img
                                        src={slide.preview_picture?.[0] ?? ''}
                                        width='560px'
                                        height='311'
                                        alt={slide.name}
                                        className={style.slide__preview}
                                      />
                                      <div className={style.slide__button_positioner}>
                                        <PlayButton
                                          onClick={() => {
                                            setPlayVideo(
                                        `contests_slider_${String(slide.id)}`
                                            )
                                          }}
                                        />
                                      </div>
                                      <div
                                        title={slide.name}
                                        className={style.slide__content}
                                      >
                                        <span className={style.slide__title}>
                                          {slide.name}
                                        </span>
                                      </div>
                                    </>
                                    )}
                              </SwiperSlide>
                            )
                          })
                        )}
                  </Swiper>
                </div>
              </div>
            </Container>
            {element.property_lessons_value.length > 0
              ? (
                <LessonsSlider
                  lessons={element.property_lessons_value}
                  prefix={`contests_${String(element.id)}`}
                  backLink={location.pathname}
                  backTitle={pageTitle}
                />
                )
              : null}
          </React.Fragment>
        )
      })}
    </Section>
  )
}

export default Contests
